'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'cherries';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'e0ec';
var svgPathData = 'M288 40l12.5-20.5L269.1 .3l-4.9 36.5s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0l0 .1-.1 .8c-.1 .7-.3 1.9-.6 3.5c-.6 3.1-1.5 7.9-2.9 13.9c-2.8 12.2-7.5 29.7-15.2 50.7c-13.9 38.3-37.3 87.6-76 136.4C152.3 233.5 126.6 224 96 224c0 0-96 0-96 112C0 480 144 512 192 512s192-16 192-176c0-112-96-112-96-112c-20.2 0-38.2 4.1-53.1 9.5c26.5-40.4 44.1-79.4 55.7-111.2c5.7-15.6 9.9-29.6 13.1-41.3c11.9 9.5 26.3 22.2 41 37.6c29.1 30.7 58.2 71.2 72.2 119.6c-12-5.3-27-10.3-44.1-12.7c16.3 14.8 30.1 35.3 37.4 63c1.8 1 3.3 2 4.6 2.8c1.5 1 2.6 1.8 3.2 2.2l.4 .3L448 317.5l29.7-23.7 .4-.3c.6-.4 1.6-1.2 3.2-2.2c3.1-2 8-4.9 14.2-7.8c12.6-5.9 29.3-11.3 48-11.4c.1 0 .2 0 .4 0l.3 0c1.1 .1 3.1 .3 5.7 .8c5.3 1 11.9 3 18 6.6c9.1 5.3 24.2 17.4 24.2 56.5c0 62-26.1 90.5-53.8 106.3c-31.5 18-69.7 21.7-90.2 21.7c-12.3 0-36.6-3.4-61.7-13.4c-9.2 14.8-20.2 27.5-32.3 38.2C390.4 506.3 427.7 512 448 512c48 0 192-16 192-176c0-112-96-112-96-112c-32.3 0-59.3 10.6-76.3 19.6c-14.3-67.2-52.9-120.9-88.3-158.2C359.3 64.4 339.8 48 325.3 36.9c-7.3-5.6-13.3-9.8-17.6-12.7c-2.2-1.5-3.9-2.6-5.1-3.4c-.6-.4-1.1-.7-1.4-.9l-.4-.3-.1-.1c0 0 0 0 0 0c0 0 0 0 0 0L288 40zm-.6 232c.2 0 .4 0 .7 .1c1.1 .1 3.1 .3 5.7 .8c5.3 1 11.9 3 18 6.6c9.1 5.3 24.2 17.4 24.2 56.5c0 62-26.1 90.5-53.8 106.3c-31.5 18-69.7 21.7-90.2 21.7c-16.7 0-55.6-6.3-88.7-26.8C72.7 418.3 48 388.4 48 336c0-39.1 15.1-51.2 24.2-56.5c6.1-3.6 12.7-5.6 18-6.6c2.6-.5 4.6-.7 5.7-.8c.3 0 .6 0 .7-.1c18.7 .1 35.4 5.5 48 11.4c6.2 2.9 11.1 5.8 14.2 7.8c1.5 1 2.6 1.8 3.2 2.2l.4 .3L192 317.5l29.7-23.7 .4-.3c.6-.4 1.6-1.2 3.2-2.2c3.1-2 8-4.9 14.2-7.8c12.6-5.9 29.3-11.3 48-11.4z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCherries = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;